import {
  getDrawingsList,
  getExportModel,
  getDrawingsExportList,
  postUpdateAddAllExport,
  postUploadImage,
  getImageMod,
  getDimensions,
  saveDimensions
} from "./services";

export async function getDrawingsListAction({ commit }, payload) {
  try {
    return (await getDrawingsList(payload)).data;
  } catch (e) {
    console.log(e);
  }
}
export async function getExportModelAction({ commit }) {
  try {
    return (await getExportModel()).data;
  } catch (e) {
    console.log(e);
  }
}
export async function getDrawingsExportListAction({ commit }) {
  try {
    return (await getDrawingsExportList()).data;
  } catch (e) {
    console.log(e);
  }
}
export async function postUpdateAddAllExportAction({ commit },payload) {
  try {
    return (await postUpdateAddAllExport(payload)).data;
  } catch (e) {
    console.log(e);
  }
}
export async function postUploadImageAction({ commit }, payload) {
  try {
    return await postUploadImage(payload);
  } catch (e) {
    console.log(e);
  }
}
export async function getImageModAction({ commit }, payload) {
  try {
    return (await getImageMod(payload)).data;
  } catch (e) {
    console.log(e);
  }
}
export async function getDimensionsAction({ commit }, payload) {
  try {
    return (await getDimensions(payload)).data;
  } catch (e) {
    console.log(e);
  }
}
export async function saveDimensionsAction({ commit }, payload) {
  try {
    return (await saveDimensions(payload)).data;
  } catch (e) {

  }
}
